import React, { Component } from 'react';
import Dom from 'react-dom';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-flexbox-grid';
import { is, times, indexOf, path } from 'ramda';
import { Collapse } from 'react-collapse';
import { intlShape, injectIntl } from 'react-intl';

import Paper from 'material-ui/Paper';
import Slider from 'material-ui/Slider';
import EnhancedButton from 'material-ui/internal/EnhancedButton';

import VASScale from '../../assets/VAS-vertical.svg';

import {
  sectionHeader,
  sectionIndicator,
  active,
  done,
  section,
  answerWrapper,
  answer,
  answerHealthToday,
  answerHealthTodayScale,
  answerNumber,
  selectionNumber,
  sectionBottom,
  selectedAnswer,
  connector,
  headerAnswerText,
  eq5dSectionHeader,
} from './ScaleField.less';

import { wrapper, selection, /* gradeIndicator, */ selected } from '../../../Status/components/Grade/Grade.less';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import { colors } from 'styles/provider';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

const theme2 = getMuiTheme({
  slider: {
    trackSize: 8,
    handleSizeDisabled: 25,
    handleSize: 25,
    selectionColor: colors.clrSecondary,
    handleFillColor: colors.clrSecondary,
    rippleColor: colors.clrSecondary,
  },
});

const renderQuestion = (name, n, vertical, getMessage, onChange, checkValue, fm, messages, instrument) => {
  const ifDescription = !!messages[`${instrument}.${name}.title.description`];

  return (
    <Col key={`${name}`} xs={12} sm={10}>
      {ifDescription && (
        <div style={{ marginTop: '', marginBottom: '2rem' }}>{getMessage(name, 'title.description')}</div>
      )}
      {!vertical && <Row>{times(renderValueButton(name, getMessage, onChange, checkValue), n)}</Row>}
      {vertical && (
        <div>
          {times(renderVerticalValueButton(name, getMessage, onChange, checkValue), n)}{' '}
          <Row center="xs" style={{ margin: '3rem 0 2rem 0' }}>
            <Col>{fm({ id: 'eq5d.trademark' })}</Col>
          </Row>
        </div>
      )}
    </Col>
  );
};

const renderValueButton = (name, getMessage, onChange, checkValue) => n => (
  <Col
    key={`${name}_${n}`}
    xs={12}
    sm={2.2}
    className={`${answerWrapper} ${checkValue(name, n + 1) ? selectedAnswer : ''}`}
  >
    <Paper className={answer} onClick={() => onChange(name, n + 1)}>
      <Row middle="xs" center="xs">
        <Col xs={2}>
          <div className={answerNumber} children={n + 1} />
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <p>{getMessage(name, n + 1)}</p>
        </Col>
      </Row>
    </Paper>
  </Col>
);

const renderVerticalValueButton = (name, getMessage, onChange, checkValue) => n => (
  <div key={n} className={wrapper + (checkValue(name, n + 1) ? ' ' + selected : '')}>
    <EnhancedButton
      onClick={() => onChange(name, n + 1)}
      style={{ width: '100%', textAlign: 'left', overflow: 'visible', paddingLeft: '1.75rem' }}
    >
      <Paper className={selection} zDepth={2}>
        <Row style={{ height: '100%' }} middle="xs">
          {/* <Col xs={2} sm={1} style={{ maxWidth: '3.5rem' }}>
            <div className={gradeIndicator}>{n + 1}</div>
          </Col> */}
          <Col xs={12} sm={12} style={{ padding: '1rem 3rem' }}>
            {getMessage(name, n + 1)}
          </Col>
        </Row>
      </Paper>
    </EnhancedButton>
  </div>
);

const renderYourHealthToday = (name, getMessage, onSliderChange, getSliderValue, fm) => (
  <div>
    <div>
      <ul>
        <li>{getMessage('yourHealthToday', 'description.1')}</li>
        <li>{getMessage('yourHealthToday', 'description.2')}</li>
        <li dangerouslySetInnerHTML={{ __html: getMessage('yourHealthToday', 'description.3') }} />
        <li>{getMessage('yourHealthToday', 'description.4')}</li>
      </ul>
    </div>
    <Row className={answerHealthToday} style={{ marginTop: '5rem' }}>
      <Col xs={7} md={9} style={{ marginRight: '4rem' }}>
        <Row center="xs" middle="xs" style={{ fontWeight: 'bold', height: '70%', fontSize: '2rem' }}>
          <Col>
            {getMessage(name, 'score')} {getSliderValue('yourHealthToday')}
          </Col>
        </Row>
      </Col>

      <Col className={answerHealthTodayScale}>
        <Row>
          <Col xs>
            <MuiThemeProvider muiTheme={theme2}>
              <div style={{ position: 'relative', height: '60rem' }}>
                <Slider
                  min={0}
                  max={100}
                  axis="y"
                  step={1}
                  value={getSliderValue('yourHealthToday')}
                  onChange={onSliderChange}
                  style={{
                    height: '80%',
                    margin: 0,
                    padding: 0,
                    zIndex: 100,
                  }}
                  sliderStyle={{
                    zIndex: 99,
                  }}
                  disabled={!onSliderChange}
                />

                <div
                  style={{
                    position: 'absolute',
                    top: '-6.3rem',
                    left: '-4.8rem',
                    width: '15rem',
                    userSelect: 'none',
                  }}
                >
                  <div>
                    <b
                      style={{
                        fontSize: '1.5rem',
                        textAlign: 'center',
                      }}
                    >
                      {fm({ id: 'eq5d.yourHealthToday.best' })}
                    </b>
                  </div>
                  <div>
                    <img src={VASScale} style={{ height: 60 * 0.863 + 'rem' }} draggable="false" />
                  </div>
                  <div>
                    <b
                      style={{
                        fontSize: '1.5rem',
                        textAlign: 'center',
                      }}
                    >
                      {fm({ id: 'eq5d.yourHealthToday.worst' })}
                    </b>
                  </div>
                </div>
              </div>
            </MuiThemeProvider>
          </Col>
        </Row>
      </Col>
    </Row>

    <Row center="xs" style={{ margin: '2rem 0' }}>
      <Col>{fm({ id: 'eq5d.trademark' })}</Col>
    </Row>
  </div>
);

const SectionHeader = ({ name, isActiveStep, onStepChange, step, value, getLabel, getValue }) => (
  <Row
    middle="xs"
    className={`${sectionHeader} ${is(Number, value) ? done : isActiveStep(step) ? active : ''}`}
    onClick={() => onStepChange(step)}
  >
    <Col xs={2} sm={1}>
      <div className={sectionIndicator} />
    </Col>
    <Col xs={3} sm={2}>
      <h6>
        <b>{name !== 'yourHealthToday' && getLabel(name)}</b>
      </h6>
    </Col>
    <Col xs={8} className={headerAnswerText}>
      {is(Number, value) && name !== 'yourHealthToday' && <p children={getValue(name, value)} />}
    </Col>
    <Col xsOffset={5} smOffset={0} xs={1}>
      <h6 className={selectionNumber}>{(value !== null && is(Number, value) && value.toString()) || ''}</h6>
    </Col>
  </Row>
);

class EditContainer extends Component {
  constructor(props) {
    super(props);
    const { localeMessage, instrument } = this.props;
    this.state = { step: 0 };
    this.handleStepChange = step => this.setState({ step });
    this.isActiveStep = step => this.props.editing && this.state.step === step;
    this.getValue = (name, value) => localeMessage(`${instrument}.${name}.${value}`);
    this.getLabel = name => localeMessage(`${instrument}.${name}.title`);

    this.autoScroll = () => {
      const { sectionNames, isInDialog } = this.props;
      if (this.state.step >= 0) {
        const firstNode = Dom.findDOMNode(this.refs[sectionNames[0]]);

        const multiplier = instrument === 'eq5d' ? 650 : 90;
        const offset = instrument === 'eq5d' ? 500 : 22;

        const topCoordinate = firstNode.offsetTop + offset + (this.state.step - 1) * multiplier;
        if (!isInDialog) {
          window.scroll({
            top: topCoordinate,
            left: 0,
            behavior: 'smooth',
          });
        }
      } else {
        this.setState({ step: null });
      }
      return true;
    };
  }

  render() {
    const {
      sectionNames,
      input,
      instrument,
      intl: { formatMessage, messages },
    } = this.props;
    const { handleStepChange, isActiveStep, getLabel, getValue } = this;
    const handleSectionChange = (name, value) => {
      const lastStep = indexOf(name, sectionNames) === sectionNames.length - 1;

      input.onChange({ ...input.value, [name]: value });
      this.setState({
        step: !lastStep ? indexOf(name, sectionNames) + 1 : null,
      });
      !lastStep && setTimeout(this.autoScroll, 450);
    };
    const handleSliderChange = (event, value) => {
      input.onChange({ ...input.value, yourHealthToday: value });
    };
    const getInputValue = name => {
      return input.value[name];
    };
    const checkValue = (name, value) => input.value && input.value[name] && input.value[name] === value;
    return instrument === 'eq5d' ? (
      <div>
        {sectionNames.map((d, i) => (
          <div key={d} ref={d}>
            {d !== 'yourHealthToday' && (
              <div style={{ marginTop: '', marginBottom: '1rem' }}>{formatMessage({ id: 'eq5d.info.3' })}</div>
            )}
            {d !== 'yourHealthToday' && (
              <Row style={{ height: '6rem', padding: '0 1rem', marginBottom: '1rem' }} middle="xs">
                <Col className={`${eq5dSectionHeader}`}>{getLabel(d)}</Col>
              </Row>
            )}
            {d !== 'yourHealthToday' && (
              <div>
                {renderQuestion(
                  d,
                  5,
                  instrument === 'eq5d',
                  getValue,
                  handleSectionChange,
                  checkValue,
                  formatMessage,
                  messages,
                  instrument,
                )}
                <div
                  style={{
                    borderBottom: '1px solid black',
                    width: '100%',
                    margin: '0 auto 3rem auto',
                    paddingTop: '1rem',
                  }}
                />
              </div>
            )}
            {d === 'yourHealthToday' &&
              renderYourHealthToday(
                d,
                getValue,
                input.onChange ? handleSliderChange : null,
                getInputValue,
                formatMessage,
              )}
          </div>
        ))}
      </div>
    ) : (
      <div>
        {sectionNames.map((d, i) => (
          <div key={d} ref={d}>
            <SectionHeader
              name={d}
              isActiveStep={isActiveStep}
              onStepChange={handleStepChange}
              step={i}
              getLabel={getLabel}
              getValue={getValue}
              value={path(['value', [d]], input)}
            />
            <Collapse isOpened={isActiveStep(i)}>
              <Row className={section}>
                <Col xs={0} sm={1}>
                  <div className={connector} />
                </Col>
                {renderQuestion(
                  d,
                  5,
                  false,
                  getValue,
                  handleSectionChange,
                  checkValue,
                  formatMessage,
                  messages,
                  instrument,
                )}
              </Row>
            </Collapse>
            {sectionNames.length !== i + 1 && (
              <Row className={sectionBottom}>
                <Col xs={0} sm={1}>
                  <div className={connector} />
                </Col>
              </Row>
            )}
          </div>
        ))}
      </div>
    );
  }
}

EditContainer.propTypes = {
  input: PropTypes.object,
  localeMessage: PropTypes.func.isRequired,
  instrument: PropTypes.string,
  sectionNames: PropTypes.arrayOf(PropTypes.string).isRequired,
  editing: PropTypes.bool,
  intl: intlShape,
  isInDialog: PropTypes.bool,
};

SectionHeader.propTypes = {
  name: PropTypes.string.isRequired,
  isActiveStep: PropTypes.func.isRequired,
  onStepChange: PropTypes.func.isRequired,
  step: PropTypes.number.isRequired,
  getLabel: PropTypes.func.isRequired,
  getValue: PropTypes.func.isRequired,
  value: PropTypes.number,
};

export default injectIntl(EditContainer);
